import 'reflect-metadata';
import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from 'class-transformer';

export class Article {
  id: number;
  title: string;
  description: string;
  content: string;

  @Expose({ name: 'image_preview' })
  imagePreview: string;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt?: Date;

  constructor(
    id: number,
    title: string,
    description: string,
    content: string,
    imagePreview: string,
    updatedAt?: Date
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.content = content;
    this.imagePreview = imagePreview;
    this.updatedAt = updatedAt;
  }

  static fromJson(json: Record<string, any>): Article {
    return plainToInstance(Article, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
